<template>
	<AppModal :settings="settings">
		<UserLevelModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import UserLevelModalContent from './UserLevelModalContent';

export default {
	components: {
		AppModal,
		UserLevelModalContent,
	},
	data() {
		return {
			settings: {
				name: 'modalUserLevel',
				title: '하이모 홈페이지 회원 등급',
				isOpen: true,
			},
		};
	},
};
</script>
